import React, { useState } from 'react'
import useCustomers from '../../hooks/api/useCustomers'

import AutocompleteFilter from './Autocomplete'

const Customer = ({ selectedCustomers, setSelectedCustomers, ...props }) => {
  const [queryString, setQueryString] = useState('')

  const { customers, ..._customers } = useCustomers(queryString, {
    is_claimed: true,
  })

  return (
    <>
      <AutocompleteFilter
        {...props}
        multiple
        options={customers}
        value={selectedCustomers}
        setQueryString={setQueryString}
        getOptionLabel={(customer) => customer.name}
        onChange={(_, value) => setSelectedCustomers(value)}
        placeholder={'Accounts'}
      />
    </>
  )
}

export default Customer
